document.addEventListener('DOMContentLoaded', function() {
    const colorSwatchesNew = document.querySelectorAll('.color-swatch-new');

        colorSwatchesNew.forEach(colorSwatchNew => {
        const image1Src = colorSwatchNew.getAttribute('data-image-1');
        const image2Src = colorSwatchNew.getAttribute('data-image-2');

        if (image1Src && image2Src) {
            colorSwatchNew.addEventListener('click', function() {
                console.log('Color swatch clicked:', colorSwatchNew);
                const colorName = colorSwatchNew.getAttribute('data-color-name');
                const priceColor = colorSwatchNew.getAttribute('data-price');
                const comparePriceColor = colorSwatchNew.getAttribute('data-compare-price');
                const dataPercentSale = colorSwatchNew.getAttribute('data-percent-sale');
                const dataUrlPro = colorSwatchNew.getAttribute('data-pro-url');

                const cardInner = colorSwatchNew.closest('.card--standard');

                cardInner.querySelectorAll('color-swatch-new').forEach(swatch => {
                    swatch.classList.remove('active');
                });

                colorSwatchNew.classList.add('active');

                const checkProductId = colorSwatchNew.getAttribute('data-check-product-id');

                cardInner.querySelectorAll('product-form').forEach(productForm => {
                    const productId = productForm.getAttribute('product-id');


                    if (productId === checkProductId) {
                        productForm.classList.add('active');
                    } else {
                        productForm.classList.remove('active');
                    }
                });

                if (cardInner) {

                    const image1 = cardInner.querySelector('.image-1');
                    const image2 = cardInner.querySelector('.image-2');

                    if (image1) {
                        image1.src = image1Src;
                    }

                    if (image2) {
                        image2.src = image2Src;
                    }
                    const productUrlOri = cardInner.querySelector('.product-url-ori');
                    if(productUrlOri) {
                        productUrlOri.href = dataUrlPro;
                    }

                    const colorDetails = cardInner.querySelector('.color-details');
                    if (colorDetails) {
                        colorDetails.textContent = colorName;
                    }

                    const priceDetails = cardInner.querySelector('.price')
                    if(priceColor){
                        priceDetails.textContent = priceColor;
                    }

                    const comparePriceDetails = cardInner.querySelector('.compare-price');

                    if(comparePriceColor){
                        comparePriceDetails.textContent = comparePriceColor;
                    }

                    const percentSaleLabel = cardInner.querySelector('.percent-sale');

                    if (percentSaleLabel) {
                        if (dataPercentSale) {
                            percentSaleLabel.classList.add('active');
                            percentSaleLabel.textContent = dataPercentSale;
                        } else {
                            percentSaleLabel.classList.remove('active');
                        }
                    }

                    const checkComparePrice = cardInner.querySelector('.price-box');
                    if (comparePriceColor) {
                        checkComparePrice.classList.add('compare-price-box')
                    } else {
                        checkComparePrice.classList.remove('compare-price-box')
                    }
                }
            });
        }
    });
});
